module.exports = __webpack_public_path__ + "img/services.776475f9.svg";